import api from "./api";
import { API_BASE_URL } from "./endpoints";

function handleResponse(response) {
  if (response.data && response.data.success) {
    return response.data.data;
  } else {
    // Handle error response where success is false
    const message = response.data?.message || "Unknown API error";
    const error = response.data?.error || null;
    const err = new Error(message);
    err.error = error;
    err.isApiError = true;
    throw err;
  }
}

export async function getAPI(endpoint, config = {}) {
  try {
    const response = await api.get(endpoint, config);
    return handleResponse(response);
  } catch (error) {
    if (error.response?.data) {
      // Handle error response from server
      const message = error.response.data.message || "API GET error";
      const apiError = error.response.data.error || null;
      const err = new Error(message);
      err.error = apiError;
      err.isApiError = true;
      throw err;
    }
    // Handle network or other errors
    throw new Error(error.message || "Network error during GET request");
  }
}

export async function postAPI(endpoint, data = {}, config = {}) {
  try {
    const response = await api.post(endpoint, data, config);
    return handleResponse(response);
  } catch (error) {
    if (error.response?.data) {
      // Handle error response from server
      const message = error.response.data.message || "API POST error";
      const apiError = error.response.data.error || null;
      const err = new Error(message);
      err.error = apiError;
      err.isApiError = true;
      throw err;
    }
    // Handle network or other errors
    throw new Error(error.message || "Network error during POST request");
  }
}

export async function putAPI(endpoint, data = {}, config = {}) {
  try {
    const response = await api.put(endpoint, data, config);
    return handleResponse(response);
  } catch (error) {
    if (error.response?.data) {
      // Handle error response from server
      const message = error.response.data.message || "API PUT error";
      const apiError = error.response.data.error || null;
      const err = new Error(message);
      err.error = apiError;
      err.isApiError = true;
      throw err;
    }
    // Handle network or other errors
    throw new Error(error.message || "Network error during PUT request");
  }
}

export async function deleteAPI(endpoint, config = {}) {
  try {
    const response = await api.delete(endpoint, config);
    return handleResponse(response);
  } catch (error) {
    if (error.response?.data) {
      // Handle error response from server
      const message = error.response.data.message || "API DELETE error";
      const apiError = error.response.data.error || null;
      const err = new Error(message);
      err.error = apiError;
      err.isApiError = true;
      throw err;
    }
    // Handle network or other errors
    throw new Error(error.message || "Network error during DELETE request");
  }
}
